<template>
  <div class="centerCenter">
    <div class="container text-center">
      <router-link to="/">
        <img
          class="d-block mx-auto mb-4"
          src="../assets/logo_default.svg"
          alt
          width="100"
          height="100"
        />
      </router-link>

      <b-alert
        v-if="spectateIntent.length > 0"
        v-model="showJoinAlert"
        variant="warning"
        dismissible
      >
        <strong>Hey there!</strong> Before you can join a quiz, you need to sign
        in to your account. <br />If you only want to follow the scores:
        <span class="tq-blue tq-hover-a" @click.prevent="spectateClicked"
          >Spectate the quiz here.</span
        >
      </b-alert>

      <form id="signinform" class="form-signin">
        <h2 class="form-signin-heading py-3">Sign in to TopQuiz!</h2>

        <div
          id="alertJoinIntent"
          class="alert alert-warning alert-dismissible collapse"
          role="alert"
        >
          <a href="#" class="close" data-dismiss="alert" aria-label="close"
            >&times;</a
          >
          <strong>Hey there!</strong> Before you can join a quiz, you need to
          sign in to your account. <br />If you only want to follow the scores:
          <a id="spectateLink">Spectate the quiz here.</a>
        </div>

        <label for="inputUserName" class="float-left">Username or e-mail</label>
        <b-form-input
          v-model="username"
          v-bind:class="{ 'is-invalid': invalid_username }"
          class="mb-2"
          placeholder="Username"
          v-on:change="usernameChanged"
          required
          autofocus
        ></b-form-input>
        <label for="passWord" class="float-left">Password</label>
        <b-form-input
          v-model="password"
          type="password"
          v-bind:class="{ 'is-invalid': invalid_password }"
          class="form-control mb-4"
          v-on:change="passwordChanged"
          placeholder="Password"
          required
        ></b-form-input>

        <div
          id="alertCredentials"
          class="alert alert-danger collapse"
          role="alert"
        >
          <strong>Whoops!</strong> The credentials you entered are not valid.
          Please try again.
        </div>

        <b-button
          :disabled="loggingIn"
          block
          variant="primary"
          size="lg"
          type="submit"
          @click.prevent="login"
          >Sign in</b-button
        >
      </form>

      <div class="mt-3 text-small">
        Forgot your password?
        <router-link to="/password">Reset it here</router-link>
      </div>
      <div class="mt-1 text-small">
        No account yet?
        <router-link to="/register">Register here</router-link>
      </div>
      <div class="mt-5">
        <router-link class="btn-lg btn-secondary px-5" to="/guest"
          >Join as a guest?</router-link
        >
      </div>
      <p class="mt-5 mb-3 text-muted holds-topquizVersionInfo"></p>

      <slot name="footer"></slot>
    </div>

    <!-- /container -->
  </div>
</template>

<script>
export default {
  name: "Login",
  created() {
    this.$emit("toggle-navbar", false);
    this.$emit("full-body", true);

    var joinIntent = localStorage.getItem("JoinIntent");
    if (joinIntent) {
      this.$topquiz.sendCommand("getSpectateIntentFromJoinIntent", joinIntent);
      this.showJoinAlert = true;
    }

    this.$topquiz.on(
      this,
      "getSpectateIntentFromJoinIntent_success",
      params => {
        this.spectateIntent = "/spectate/" + params[0];
      }
    );

    this.$topquiz.checkSession(() => {
      this.$router.replace("/dashboard");
    });

    this.$topquiz.on(this, "sign-in_success", params => {
      this.loggingIn = false;
      localStorage.setItem("session_key", params[0]);
      this.$topquiz.checkSession(() => {
        this.$router.replace("/dashboard");
      });
    });

    this.$topquiz.on(this, "sign-in_error", params => {
      this.loggingIn = false;
      if (params[0] == -1) {
        this.$router.push("/register/confirm/" + btoa(this.username));
        return;
      }

      this.invalid_password = true;
      this.password = "";
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  data() {
    return {
      username: "",
      password: "",
      invalid_username: false,
      invalid_password: false,
      showJoinAlert: false,
      spectateIntent: "",
      loggingIn: false
    };
  },
  methods: {
    login: function() {
      if (!this.username) {
        this.invalid_username = true;
        return;
      }

      this.loggingIn = true;
      this.$topquiz.sendCommand(
        "sign-in",
        this.username,
        "<hidden>" + this.password
      );
    },
    passwordChanged: function() {
      this.invalid_password = false;
    },
    usernameChanged: function() {
      this.invalid_username = false;
    },
    spectateClicked() {
      localStorage.removeItem("JoinIntent");
      this.$router.push(this.spectateIntent);
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 400px;
}
</style>
